module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/inner-4-fc400ad2896fa55070a6dd700389f19b.jpg";